import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card mb-1\"><div class=\"card-body\"><div class=\"row\"><div class=\"input-group\"><input type=\"text\" class=\"form-control w-25\" placeholder=\"Enter Search Key !\"><span class=\"input-group-text\" id=\"basic-addon1\">From</span><input type=\"date\" class=\"form-control\" placeholder=\"Enter Search Key !\"><span class=\"input-group-text\" id=\"basic-addon1\">To</span><input type=\"date\" class=\"form-control\" placeholder=\"Enter Search Key !\"><button type=\"button\" class=\"btn btn-primary me-1 ms-1\">Search</button><button type=\"button\" class=\"btn btn-default border\">Clear</button></div></div></div></div><div class=\"card mb-1\"><div class=\"card-body\"><table class=\"table card-table\"><thead><tr><th>Id</th><th>Invoice Id</th><th>Customer Name</th><th>Date</th><th>SubTotal Sale</th><th>Action</th></tr></thead><tbody class=\"table-border-bottom-0\"></tbody></table></div></div><div class=\"card\"><div class=\"card-body d-flex justify-content-center\"><nav aria-label=\"Page navigation\"><ul class=\"pagination mb-0\"><li class=\"page-item first\"><a class=\"page-link\" href=\"javascript:void(0);\"><i class=\"tf-icon bx bx-chevrons-left\"></i></a></li><li class=\"page-item prev\"><a class=\"page-link\" href=\"javascript:void(0);\"><i class=\"tf-icon bx bx-chevron-left\"></i></a></li><li class=\"page-item active\"><a class=\"page-link\" href=\"javascript:void(0);\">1</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"javascript:void(0);\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"javascript:void(0);\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"javascript:void(0);\">4</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"javascript:void(0);\">5</a></li><li class=\"page-item next\"><a class=\"page-link\" href=\"javascript:void(0);\"><i class=\"tf-icon bx bx-chevron-right\"></i></a></li><li class=\"page-item last\"><a class=\"page-link\" href=\"javascript:void(0);\"><i class=\"tf-icon bx bx-chevrons-right\"></i></a></li></ul></nav></div></div>", 3)
const _hoisted_4 = {
  class: "modal fade",
  id: "modalCenter",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title text-center",
    id: "modalCenterTitle"
  }, "Delete Confirmation !"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_8 = { class: "modal-body text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-bell bx-lg text-danger mb-3 d-inline-block" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Are You Sure to Delete ?", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Page !")
const _hoisted_12 = { class: "modal-footer text-center justify-content-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("p", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.deletevalue.name), 1),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("button", {
              "data-bs-dismiss": "modal",
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteItem(_ctx.deletevalue.id)))
            }, "Confirm")
          ])
        ])
      ])
    ])
  ]))
}